/*!
 * Upgrade Clinic — bundled custom JS
 * Generated by scripts/build-js-bundle.mjs — DO NOT EDIT this file directly.
 * Edit source files in theme/assets/upgrade-*.js and re-run `npm run build:js`.
 */

(function () {
"use strict";
(function autoRedirect() {
function go() {
var el = document.querySelector("[data-redirect-to]");
if (el) {
var url = el.getAttribute("data-redirect-to");
if (url) window.location.replace(url);
}
}
if (document.readyState === "loading") {
document.addEventListener("DOMContentLoaded", go);
} else {
go();
}
})();
function init() {
var host = document.getElementById("anchor-nav-host");
var spacer = document.getElementById("anchor-nav-spacer");
if (!host || !spacer) return;
var origParent = host.parentNode;
var origNext = host.nextSibling;
var isFixed = false;
var lastY = window.pageYOffset;
var SHY_THRESHOLD = 6;
var links = Array.prototype.slice.call(host.querySelectorAll(".anchor-nav__link"));
var currentLabel = host.querySelector(".anchor-nav__current");
var labelById = {};
var sectionIds = links
.map(function (l) {
var h = l.getAttribute("href");
if (!h || h.charAt(0) !== "#") return null;
var id = h.slice(1);
labelById[id] = (l.textContent || "").trim();
return id;
})
.filter(Boolean);
function originalTop() {
var ref = isFixed ? spacer : host;
return ref.getBoundingClientRect().top + window.pageYOffset;
}
function measure() {
spacer.style.height = host.offsetHeight + "px";
}
function setFixed(state) {
if (state === isFixed) return;
if (state) {
spacer.classList.add("is-active");
document.body.appendChild(host);
host.classList.add("is-fixed");
} else {
host.classList.remove("is-fixed");
if (origNext && origNext.parentNode === origParent) {
origParent.insertBefore(host, origNext);
} else {
origParent.appendChild(host);
}
spacer.classList.remove("is-active");
}
isFixed = state;
}
function onScroll() {
var y = window.pageYOffset;
var trig = originalTop();
setFixed(y >= trig);
var delta = y - lastY;
if (isFixed && Math.abs(delta) > SHY_THRESHOLD) {
if (delta < 0) host.classList.add("is-hidden");
else host.classList.remove("is-hidden");
} else if (!isFixed) {
host.classList.remove("is-hidden");
}
lastY = y;
var checkY = y + host.offsetHeight + 40;
var current = null;
for (var i = 0; i < sectionIds.length; i++) {
var el = document.getElementById(sectionIds[i]);
if (!el) continue;
var top = el.getBoundingClientRect().top + y;
if (top <= checkY) current = sectionIds[i];
else break;
}
for (var j = 0; j < links.length; j++) {
var match = links[j].getAttribute("href") === "#" + current;
if (match) links[j].classList.add("is-active");
else links[j].classList.remove("is-active");
}
if (currentLabel && current && labelById[current]) {
currentLabel.textContent = labelById[current];
}
}
var ticking = false;
function onScrollThrottled() {
if (ticking) return;
ticking = true;
window.requestAnimationFrame(function () {
onScroll();
ticking = false;
});
}
measure();
window.addEventListener("scroll", onScrollThrottled, { passive: true });
window.addEventListener("resize", function () { measure(); onScroll(); }, { passive: true });
if (window.ResizeObserver) {
try { new ResizeObserver(measure).observe(host); } catch (e) {  }
}
onScroll();
setTimeout(function () { measure(); onScroll(); }, 100);
}
if (document.readyState === "loading") {
document.addEventListener("DOMContentLoaded", init);
} else {
init();
}
})();


(function () {
"use strict";
var CDN = "//www.upgradeclinic.cz/cdn/shop/files/";
var ITEMS = [
{
title: "Vyhlazení mimických vrásek",
sub: "Aplikace neuromodulátoru — od 4 000 Kč",
url: "/pages/zakrok-vyhlazeni-vrasek",
img: "Vyhlazen_vr_sek.jpg",
kw: "botox dysport jeuveau xeomin azzalure daxxify letybo allegran ipsen vrasky mimicke vrasky vyhlazeni vrasek husi nozicky lvi vrasky celo neuromodulator injekce vrasky gummy smile lip flip lipflip masseter pocenie podpazi hyperhidroza nefertiti toxin kuracke vrasky vyplneni vrasek glabella mezi boci ocni okoli zvykaci svaly krk cely oblicej brada nos pany muzi botulotoxin",
},
{
title: "Zvětšení rtů kyselinou hyaluronovou",
sub: "Lip filler, výplně, rozpuštění",
url: "/pages/zakrok-vyplne-rtu-a-kontury",
img: "vyplne.jpg",
kw: "rty vypln vyplne vyplne rtu plneni rtu objem zvetseni juvederm restylane stylage lip filler hyaluron korekce rtu rozpusteni filler hylaza kyselina hyaluronova",
},
{
title: "Modelace tváří a kontur",
sub: "Hyaluron · hydroxyapatit · kyselina polymléčná",
url: "/pages/zakrok-vyplne-tvari-a-kontur",
img: "vyplne.jpg",
kw: "vypln vypln obliceje konturovani obliceje tvare vyplne licni kosti brada vypln celist vypln spanky nosoretky nosoretni ryhy tmave kruhy slzne ryhy pod oci fillers juvederm restylane stylage uhly celisti harmonyca profhilo profilo kyselina kyselina hyaluronova radiesse radiese radiase radiasse hydroxiapatit lifting vyplne kolagenova stimulace konturovani kolagenstimulator objem sculptra polylactic plla biostimulator tenka plet kyselina polymlecna",
},
{
title: "Morpheus8 — mikrojehličkování s RF",
sub: "Zpevnění pleti, RF mikrojehlička, InMode",
url: "/pages/zakrok-morpheus8",
img: "Microneedling.jpg",
kw: "morpheus8 morpheus morfeus mikrojehlickovani radiofrekvence rf mikrojehlicky zpevneni pleti lifting podbradek zpevneni dvojita brada zpevneni krku zpevneni vicek strie celulitida inmode",
},
{
title: "Ultraformer MPT — HIFU lifting",
sub: "Ultrazvukový lifting SMAS, korejský",
url: "/pages/zakrok-ultraformer-hifu",
img: "ultraformer_zoom.jpg",
kw: "hifu ultrazvukovy lifting lifting ultraformer ulthera ultraformer mpt ultraformer iii facelift neinvazivni facelift neinvazivni lifting smas classys ovaĺ celist krk podbradek micro pulsed technology",
},
{
title: "Volnewmer — RF lifting nové generace",
sub: "Radiofrekvenční lifting bez chirurgie",
url: "/pages/zakrok-volnewmer",
img: "ultraformer_zoom.jpg",
kw: "volnewmer radiofrekvence lifting rf lifting zpevneni obliceje ultraformer morpheus8 nova generace dermabooster",
},
{
title: "Laser Fotona — lifting a omlazení",
sub: "Nd:YAG / Er:YAG, SmoothEye, 4D",
url: "/pages/zakrok-fotona-laser",
img: "ultraformer_zoom.jpg",
kw: "fotona smootheye smooth eye piano laser frac3 frac 3 4d lifting laserovy lifting laserove omlazeni laserove resurfacing laserovy peeling er yag nd yag ocni okoli lifting laser vectorlift light peel 2d 3d 4d luxusni omlazeni smoothliftin",
},
{
title: "EXION Face — bezjehlový lifting",
sub: "Radiofrekvence + ultrazvuk, BTL",
url: "/pages/zakrok-exion-face",
img: "bricho.jpg",
kw: "exion exion face btl lifting neinvazivni lifting rf morpheus8 morpheus ultraformer mpt bezjehlovy bez jehel monopolarni fokusovany ultrazvuk endogenni kyselina hyaluronova novotvorba kolagenu",
},
{
title: "Deep Glow protokol",
sub: "Hydratace, regenerace a zpevnění — 16 000 Kč",
url: "/pages/zakrok-deep-glow",
img: "Bioremodelace.jpg",
kw: "deep glow deepglow protokol hydratace regenerace kvalita pleti zpevneni red carpet bioremodelace exozomy pdrn fotona piano frac3",
},
{
title: "Mezoroller s exozomy a PDRN",
sub: "Povrchová regenerace pleti — 7 000 Kč",
url: "/pages/zakrok-mezoroller-exozomy-pdrn",
img: "Microneedling.jpg",
kw: "mezoroller mesoroller dermaroller exozomy exosomy pdrn regenerace hydratace textura kvalita pleti",
},
{
title: "Biorevitalizace — hydratace KH",
sub: "Mikroinjekce hyaluronu, oční okolí",
url: "/pages/zakrok-biorevitalizace",
img: "Bioremodelace.jpg",
kw: "biorevitalizace mezo mezoterapie skin booster skinbooster hydratace pleti sucha plet polynukleotidy rejuran nctf kyselina hyaluronova mikroinjekce nativni",
},
{
title: "Mezoterapie z lososí DNA (PDRN)",
sub: "PDRN polynukleotidy z lososí DNA",
url: "/pages/zakrok-mezoterapie-lososi-dna",
img: "Microneedling.jpg",
kw: "mezoterapie pdrn polynukleotidy lososi dna rejuran plinest regenerace jizvy akne losos ocni okoli sucha plet prsa tmave kruhy",
},
{
title: "Bioremodelace pleti",
sub: "Nejvyšší koncentrace KH (64 mg/2 ml)",
url: "/pages/zakrok-profhilo-bioremodelace",
img: "Bioremodelace.jpg",
kw: "profhilo bioremodelace ibsa sucha plet kyselina kyselina hyaluronova mezoterapie hydratace biorevitalizace mezo tenka kuze 64 mg bap technika obnova svezesti",
},
{
title: "Mikrojehličkování (Dermapen)",
sub: "Stimulace kolagenu, póry, jizvy",
url: "/pages/zakrok-microneedling",
img: "Microneedling.jpg",
kw: "dermapen mikrojehlickovani dermaroller mezoroller pory jizvy akne textura pleti elektricke mikrojehlickovani",
},
{
title: "Chemický peeling",
sub: "TCA, glykolový, mandlový peeling",
url: "/pages/zakrok-chemicky-peeling",
img: "peeling.jpg",
kw: "peeling chemicky peeling kyselinovy peeling tca peeling glykolovy peeling mandlovy peeling peeling oblicej cosmelan pigmentace textura pleti biorepeel bio re peel exfoliace kyselina",
},
{
title: "Depigmentační ošetření",
sub: "Melasma, hyperpigmentace",
url: "/pages/zakrok-cosmelan",
img: "lumecca.jpg",
kw: "cosmelan melasma depigmentace pigmentove skvrny hyperpigmentace tmave skvrny postinflamatorni pigmentace skvrny melazma tyrozinaza melanin",
},
{
title: "Lumecca IPL",
sub: "Intenzivní pulzní světlo, pigment, žilky",
url: "/pages/zakrok-lumecca-ipl",
img: "lumecca.jpg",
kw: "ipl lumecca intenzivni pulzni svetlo pigment rozsirene zilky cervene zilky fotorejuvenace akne svetlo zilky zacervenani bbl fototerapie zanet bbl hero inmode 515 1000 nm",
},
{
title: "Laserová epilace (GentleLase PRO-U)",
sub: "Candela, alexandritový 755 nm",
url: "/pages/zakrok-laserova-epilace",
img: "laserova_epilace_square.png",
kw: "epilace laserova epilace trvala epilace chloupky odstraneni chloupku alexandritovy laser bikini brazilska podpazi nohy zada hrudnik ruce laser diodovy laser candela alexandrite gentlelase pro-u 755 nm celý obličej",
},
{
title: "EXION Body — zpevnění těla",
sub: "RF + ultrazvuk, balíčky 4/7 sezení",
url: "/pages/zakrok-exion-body",
img: "bricho.jpg",
kw: "exion body telo tvarovani tela tuk redukce tuku zpevneni tela celulitida zpevneni bricha gynekomastie redukce zpevneni dvojita brada morpheus8 bricho dvojity podbradek bok hyzde stehna kolena paze zada lytka",
},
{
title: "Morpheus8 Body — RF mikrojehlička",
sub: "Strie, celulitida, uvolněná kůže",
url: "/pages/zakrok-morpheus8-body",
img: "Microneedling.jpg",
kw: "morpheus8 body morpheus body mikrojehlickovani radiofrekvence rf telo strie celulitida uvolnena kuze hubnuti porod paze stehna zada bricho inmode",
},
{
title: "PicoWay — odstranění tetování",
sub: "Pikosekundový laser Candela",
url: "/pages/zakrok-picoway",
img: "odstraneni_tetovani.jpg",
kw: "tetovani odstraneni tetovani laser laserove tetovani picoway pikosekundovy laser barevne tetovani odstraneni picosure picostar laser pigment pigmentace candela permanentni make-up oboci modra zelena",
},
{
title: "Pro muže",
sub: "Estetická medicína pro pánskou anatomii",
url: "/pages/pro-muze",
img: "08_Pro_muze.png",
kw: "pro muze men muz panove panska anatomie maskulin botox vyplne lifting laserova epilace zada hrudnik gynekomastie",
},
{
title: "Konzultace s lékařem",
sub: "Analýza pleti + plán — 1 000 Kč",
url: "/pages/konzultace",
img: "Microneedling.jpg",
kw: "konzultace consultation lekar doporuceni analyza pleti plan",
},
{
title: "Skincare konzultace s terapeutkou",
sub: "Domácí péče a kosmetika — 1 000 Kč",
url: "/pages/konzultace-skincare",
img: "Microneedling.jpg",
kw: "skincare konzultace terapeutka domaci pece kosmetika lumecca mikrojehlickovani mezoroller depigmentacni laserova epilace",
},
{
title: "Komplexní analýza — MUDr. Marada",
sub: "Anti-age plán — 4 000 Kč",
url: "/pages/konzultace-komplexni",
img: "Microneedling.jpg",
kw: "komplexni analyza anti age plan marada vystupni protokol individualni plan procedur hloubkova",
},
{ title: "Obličej", sub: "Kategorie zákroků", url: "/pages/oblicej", img: "01_Hlava_a_oblicej.png", kw: "oblicej face tvar lift vrasky" },
{ title: "Tělo", sub: "Kategorie zákroků", url: "/pages/telo", img: "02_Telo_a_hubnuti.png", kw: "telo body zpevneni tuk strie tvarovani" },
];
function normalize(s) {
return (s || "")
.toLowerCase()
.normalize("NFD")
.replace(/[̀-ͯ]/g, "")
.replace(/[^a-z0-9\s]/g, " ")
.replace(/\s+/g, " ")
.trim();
}
function escapeHtml(s) {
return (s || "").replace(/[&<>"']/g, function (c) {
return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
});
}
function scoreItem(item, queryTokens, normTitle, normHay) {
var totalScore = 0;
for (var t = 0; t < queryTokens.length; t++) {
var q = queryTokens[t];
if (!q) continue;
var tokenScore = 0;
var wbRe = new RegExp("\\b" + q.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), "i");
if (wbRe.test(normTitle)) {
if (normTitle.indexOf(q) === 0) tokenScore = 4;
else tokenScore = 3;
} else if (wbRe.test(normHay)) {
tokenScore = 2;
} else if (normHay.indexOf(q) !== -1) {
tokenScore = 1;
}
if (tokenScore === 0) return 0;
totalScore += tokenScore;
}
return totalScore;
}
function init() {
var form = document.querySelector(".zk-search");
if (!form) return;
var input = form.querySelector('input[type="search"]');
if (!input) return;
var PLACEHOLDER_HINTS = [
"Např. vrásky čela, glabella, Daxxify…",
"Např. Volnewmer, RF lifting…",
"Např. Ultraformer MPT, HIFU…",
"Např. rozpuštění výplně…",
"Např. lososí DNA, PDRN…",
"Např. EXION, gynekomastie…",
"Např. melasma, pigmentové skvrny…",
"Např. PicoWay, tetování barevné…",
"Např. bioremodelace, hydratace pleti…",
"Např. Fotona, SmoothEye, 4D…",
"Např. biostimulátor kolagenu…",
"Např. epilace bikini, brazilská…",
];
var phIndex = 0;
function rotatePlaceholder() {
if (document.activeElement === input) return;
if (input.value) return;
phIndex = (phIndex + 1) % PLACEHOLDER_HINTS.length;
input.placeholder = PLACEHOLDER_HINTS[phIndex];
}
setInterval(rotatePlaceholder, 2600);
var INDEXED = ITEMS.map(function (item) {
return {
item: item,
normTitle: normalize(item.title + " " + (item.sub || "")),
normHay: normalize(item.title + " " + (item.sub || "") + " " + (item.kw || "")),
};
});
var dropdown = document.createElement("div");
dropdown.className = "zk-search__results";
dropdown.setAttribute("role", "listbox");
document.body.appendChild(dropdown);
function position() {
var r = input.getBoundingClientRect();
dropdown.style.position = "fixed";
dropdown.style.left = r.left + "px";
dropdown.style.top = r.bottom + 8 + "px";
dropdown.style.width = r.width + "px";
}
var activeIndex = -1;
var currentMatches = [];
function render(query) {
var q = normalize(query.trim());
if (!q) {
dropdown.classList.remove("is-open");
dropdown.innerHTML = "";
currentMatches = [];
return;
}
var tokens = q.split(" ").filter(Boolean);
var scored = [];
for (var i = 0; i < INDEXED.length; i++) {
var s = scoreItem(INDEXED[i].item, tokens, INDEXED[i].normTitle, INDEXED[i].normHay);
if (s > 0) scored.push({ item: INDEXED[i].item, score: s });
}
scored.sort(function (a, b) { return b.score - a.score; });
currentMatches = scored.slice(0, 8).map(function (x) { return x.item; });
activeIndex = -1;
if (currentMatches.length === 0) {
dropdown.innerHTML =
'<div class="zk-search__empty">Nic neodpovídá hledání &bdquo;' +
escapeHtml(query) +
'&ldquo;. <a href="https://upgrade.xdent.cz/wizard/clinic-selection">Zeptejte se AI →</a></div>';
} else {
dropdown.innerHTML = currentMatches
.map(function (m, i) {
var thumb = m.img
? '<span class="zk-search__thumb" style="background-image:url(' + CDN + encodeURIComponent(m.img) + '?width=120)"></span>'
: '<span class="zk-search__thumb zk-search__thumb--blank"></span>';
return (
'<a class="zk-search__item" href="' +
m.url +
'" data-index="' +
i +
'" role="option">' +
thumb +
'<span class="zk-search__item-body">' +
'<span class="zk-search__item-title">' +
escapeHtml(m.title) +
"</span>" +
(m.sub ? '<span class="zk-search__item-sub">' + escapeHtml(m.sub) + "</span>" : "") +
"</span></a>"
);
})
.join("");
}
position();
dropdown.classList.add("is-open");
}
function highlight(idx) {
var items = dropdown.querySelectorAll(".zk-search__item");
for (var i = 0; i < items.length; i++) {
if (i === idx) items[i].classList.add("is-active");
else items[i].classList.remove("is-active");
}
activeIndex = idx;
}
input.addEventListener("input", function () { render(input.value); });
input.addEventListener("focus", function () { if (input.value.trim()) render(input.value); });
input.addEventListener("keydown", function (e) {
if (!currentMatches.length) return;
if (e.key === "ArrowDown") {
e.preventDefault();
highlight(Math.min(activeIndex + 1, currentMatches.length - 1));
} else if (e.key === "ArrowUp") {
e.preventDefault();
highlight(Math.max(activeIndex - 1, 0));
} else if (e.key === "Enter") {
if (activeIndex >= 0) {
e.preventDefault();
window.location.href = currentMatches[activeIndex].url;
} else if (currentMatches[0]) {
e.preventDefault();
window.location.href = currentMatches[0].url;
}
} else if (e.key === "Escape") {
dropdown.classList.remove("is-open");
input.blur();
}
});
document.addEventListener("click", function (e) {
if (!form.contains(e.target) && !dropdown.contains(e.target)) dropdown.classList.remove("is-open");
});
window.addEventListener("scroll", function () { if (dropdown.classList.contains("is-open")) position(); }, { passive: true });
window.addEventListener("resize", function () { if (dropdown.classList.contains("is-open")) position(); }, { passive: true });
}
if (document.readyState === "loading") {
document.addEventListener("DOMContentLoaded", init);
} else {
init();
}
})();


(function () {
"use strict";
function init() {
var groups = document.querySelectorAll(".cenik-categories");
if (!groups.length) return;
groups.forEach(function (group) {
var accs = group.querySelectorAll(":scope > .cenik-acc");
accs.forEach(function (acc) {
acc.addEventListener("toggle", function () {
if (!acc.open) return;
accs.forEach(function (other) {
if (other !== acc && other.open) {
other.removeAttribute("open");
}
});
});
});
});
}
if (document.readyState === "loading") {
document.addEventListener("DOMContentLoaded", init);
} else {
init();
}
})();


(function () {
"use strict";
var SELECTORS = [
".hero-split__cta",
".anchor-nav__cta",
".cena-headline__cta",
".cta-img__cta",
".tech-dev__proc",
".cenik-foot__cta",
".branch-hub__cta",
".upgrade-mega__cta",
].join(", ");
function attach(button) {
if (button.dataset.flairAttached === "1") return;
button.dataset.flairAttached = "1";
var flair = button.querySelector(".button__flair");
if (!flair) {
flair = document.createElement("span");
flair.className = "button__flair";
button.insertBefore(flair, button.firstChild);
}
function getXY(e) {
var r = button.getBoundingClientRect();
return {
x: ((e.clientX - r.left) / r.width) * 100,
y: ((e.clientY - r.top) / r.height) * 100,
};
}
button.addEventListener("mouseenter", function (e) {
var p = getXY(e);
flair.style.transform = "translate(" + p.x + "%, " + p.y + "%) scale(1)";
});
button.addEventListener("mousemove", function (e) {
var p = getXY(e);
flair.style.transform = "translate(" + p.x + "%, " + p.y + "%) scale(1)";
});
button.addEventListener("mouseleave", function (e) {
var p = getXY(e);
flair.style.transform = "translate(" + p.x + "%, " + p.y + "%) scale(0)";
});
}
function init() {
document.querySelectorAll(SELECTORS).forEach(attach);
}
if (document.readyState === "loading") {
document.addEventListener("DOMContentLoaded", init);
} else {
init();
}
setTimeout(init, 600);
})();


(() => {
function init(root = document) {
root.querySelectorAll('.upgrade-procedure-menu').forEach((menu) => {
if (menu.dataset.initialized) return;
menu.dataset.initialized = 'true';
const summary = menu.querySelector('summary');
let closeTimer;
const desktop = () => !menu.classList.contains('upgrade-procedure-menu--mobile') &&
window.matchMedia('(min-width: 1025px) and (hover: hover)').matches;
menu.addEventListener('pointerenter', (event) => {
clearTimeout(closeTimer);
if (desktop() && event.pointerType === 'mouse') menu.open = true;
});
menu.addEventListener('pointerleave', () => {
if (desktop()) closeTimer = setTimeout(() => {
if (!menu.contains(document.activeElement)) menu.open = false;
}, 180);
});
menu.addEventListener('focusout', (event) => {
if (event.relatedTarget && !menu.contains(event.relatedTarget)) menu.open = false;
});
menu.addEventListener('keydown', (event) => {
if (event.key === 'Escape' && menu.open) {
event.preventDefault();
event.stopPropagation();
menu.open = false;
summary.focus();
}
});
menu.addEventListener('click', (event) => {
if (event.target.closest('a')) setTimeout(() => {
menu.open = false;
menu.closest('menu-drawer')?.close();
}, 0);
});
document.addEventListener('pointerdown', (event) => {
if (!menu.contains(event.target)) menu.open = false;
});
});
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
else init();
document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
